import React, { useEffect } from "react";
import "../../App.scss";
import HeaderBar from "./headerBar";
import FootBar from "./footerbar";
import "./case-study.scss";

function Section({ title, children }) {
  return (
    <section className="case-study__section">
      <div className="case-study__section-header">
        <p className="case-study__eyebrow">{title}</p>
      </div>
      <div className="case-study__section-body">{children}</div>
    </section>
  );
}

function RichParagraphs({ items }) {
  return items.map((item) => <p key={item}>{item}</p>);
}

function BulletList({ items, className = "" }) {
  return (
    <ul className={`case-study__list ${className}`.trim()}>
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export default function CaseStudyPage({ study }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeaderBar
        Descr={study.header.descr}
        Location={study.header.location}
        time={study.header.time}
      />

      <div className="case-study">
        <section className="case-study__hero">
          <div className="case-study__hero-copy">
            <p className="case-study__category">{study.category}</p>
            <h1>{study.title}</h1>
            <p className="case-study__summary">{study.overview.intro}</p>
            <div className="case-study__meta">
              <div>
                <span>Organization</span>
                <strong>{study.overview.organization}</strong>
              </div>
              <div>
                <span>System / Product</span>
                <strong>{study.overview.product}</strong>
              </div>
              <div>
                <span>Timeframe</span>
                <strong>{study.overview.timeframe}</strong>
              </div>
              <div>
                <span>Role</span>
                <strong>{study.overview.role}</strong>
              </div>
            </div>
          </div>
          <div className="case-study__hero-media">
            <img src={study.heroImage} alt={study.title} />
          </div>
        </section>

        <Section title="Project Overview">
          <p>{study.overview.summary}</p>
        </Section>

        <Section title="Problem / Context">
          <RichParagraphs items={study.problem} />
        </Section>

        <Section title="Challenge / Complexity">
          <RichParagraphs items={study.challenge} />
        </Section>

        <Section title="Role & Responsibilities">
          <BulletList items={study.responsibilities} />
        </Section>

        <Section title="Approach">
          <RichParagraphs items={study.approach} />
        </Section>

        <Section title="Key Contributions">
          <BulletList
            items={study.contributions}
            className="case-study__list--accent"
          />
        </Section>

        <Section title="Outcomes & Impact">
          <BulletList items={study.outcomes} />
        </Section>

        {study.artifacts?.length ? (
          <Section title="Artifacts / Visuals">
            <div className="case-study__artifacts">
              {study.artifacts.map((artifact) => (
                <figure className="case-study__artifact" key={artifact.title}>
                  <img src={artifact.image} alt={artifact.alt} />
                  <figcaption>
                    <h3>{artifact.title}</h3>
                    <p>{artifact.description}</p>
                    <p className="case-study__artifact-impact">
                      Why it matters: {artifact.impact}
                    </p>
                  </figcaption>
                </figure>
              ))}
            </div>
          </Section>
        ) : null}

        {study.reflection ? (
          <Section title="Reflection / Takeaways">
            <p>{study.reflection}</p>
          </Section>
        ) : null}
      </div>

      <FootBar Descr="Get in Touch -->" Location="mike@mcameron.io" />
    </>
  );
}
